import { call, put, takeEvery, select } from 'redux-saga/effects'
import { change, startSubmit, stopSubmit, getFormValues } from 'redux-form/immutable'
import uuidv1 from 'uuid/v1'

import { promisedCanvasToBlob } from 'helpers/promises/promisedCanvasToBlob'
import { showError } from 'store/entities/toastr/utils'
import { uploadFileToS3 } from 'store/entities/api/sagas/s3PolicySagas'
import { addImageToGallery, setIsButtonDisable, uploadImage, setIsImageNameExist } from 'store/entities/gallery/actions'
import { EDIT_ACTIVITY_FORM_NAME, CREATE_ACTIVITY_FORM_NAME } from 'app/constants/activities'
import { getIsImageNameExist } from 'store/entities/gallery/selectors.js'
import { getActivities } from 'store/entities/protracks/activities/actions'
import { getLevelsView } from 'store/entities/protracks/levels/selectors'
import { getViewProtrackId } from 'store/entities/protracks/selectors'

export default function* uploadAdminWelcomeEmailImageSaga() {
  yield takeEvery(uploadImage, handleUploadImageRequest)
}

export function* handleUploadImageRequest({ payload }) {
  const { image, formName, formField, s3Entity, isConfirmRewriteImage } = payload
  try {
    const { file, ext, mime } = image
    yield put(startSubmit(formName))
    let imagePath
    if (file instanceof HTMLCanvasElement) {
      const blob = yield call(promisedCanvasToBlob, file, mime)
      if (!!file.name && (formName === EDIT_ACTIVITY_FORM_NAME || formName === CREATE_ACTIVITY_FORM_NAME)) {
        const imageDomainWithId = (yield select(getFormValues(EDIT_ACTIVITY_FORM_NAME))).get('imageDomainWithId')
        const imageDomain = imageDomainWithId.split('_')[1]
        const imageDomainId = imageDomainWithId.split('_')[0]
        const fileName = `${imageDomain}__${file.name.split('.')[0]}`
        const fileResolution = `${file.width}x${file.height}`
        const isImageNameExist = yield select(getIsImageNameExist)
        if (isImageNameExist) {
          const hash = uuidv1()
          imagePath = yield call(uploadImageToS3, blob, ext, s3Entity, {
            fileName,
            fileResolution,
            isConfirmRewriteImage,
            imageDomainId,
            hash,
          })
          // update images for activities at store
          const levelId = yield select(getLevelsView)
          const protrackId = yield select(getViewProtrackId)
          yield put(getActivities({ protrackId, levelId }))
        } else {
          imagePath = yield call(uploadImageToS3, blob, ext, s3Entity, {
            fileName,
            fileResolution,
            isConfirmRewriteImage,
            imageDomainId,
          })
        }
        yield put(setIsButtonDisable(true))
        yield put(setIsImageNameExist(false))
      } else {
        imagePath = yield call(uploadImageToS3, blob, ext, s3Entity)
      }
    } else {
      imagePath = yield call(uploadImageToS3, file, file.name.substring(file.name.lastIndexOf('.') + 1), s3Entity)
    }
    yield put(change(formName, formField, imagePath))
    yield put(addImageToGallery(imagePath, isConfirmRewriteImage))
  } catch (badResponse) {
    showError()
  } finally {
    yield put(stopSubmit(formName))
  }
}

export function* uploadImageToS3(file, ext, s3Entity, params) {
  return yield call(uploadFileToS3, { file, ext, entity: s3Entity, params })
}
